import React, { FC } from 'react';
import AuthPage from './AuthPage';

const ForgottenPassword: FC = () => <AuthPage initialScreen="forgot" />;

export default ForgottenPassword;
